<template>
  <rabbey-base-drawer
    ref="openDrawer"
    title="Compartir Calendario"
    size="80%"
    :drawer="openDrawer"
    :before-close="handleClose"
    v-on:update:drawer="$emit('update:openDrawer', $event)"
  >
    <!-- <el-drawer
    :visible.sync="openDrawer"
    size="55%"
    title="Compartir Calendario"
    :append-to-body="append"
    :before-close="handleClose"
  > -->
    <ShareCalendar :users="users" @add-user="addUser" />
    <RemoveShareCalendar
      ref="removeSection"
      :usersInCalendar="usersInCalendar"
      @remove-user="removeUser"
      @toggle-edit="toggleEdit"
    />
  </rabbey-base-drawer>
  <!-- </el-drawer> -->
</template>

<script>
import RemoveShareCalendar from "./RemoveShareCalendar";
import ShareCalendar from "./ShareCalendar";

export default {
  name: "ShareCalendarDrawer",
  components: {
    ShareCalendar,
    RemoveShareCalendar
  },
  props: ["openDrawer", "calendarID"],
  data() {
    return {
      append: false,
      users: [],
      usersInCalendar: []
    };
  },
  methods: {
    handleClose() {
      this.$emit("close-drawer");
    },
    getAllUser() {
      this.loading = false;

      this.$http
        .get("/api/users")
        .then((resp) => {
          this.users = resp.data;
        })
        .catch(() => {
          this.$message.error("Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addUser(user) {
      this.$http
        .post("/api/Calendario/ShareCalendario", {
          CalendarID: this.calendarID,
          UserID: user.Id
        })
        .then(({ data }) => {
          if (data.Succeded) {
            let formattedUser = {
              FullName: user.FullName,
              EmployeeID: -1, // This way EmployeeID and CalendarCreatedBy wont be equal (since they are both null in this particular object)
              UserID: user.Id
            };
            this.$refs.removeSection.usersInCalendar.push(formattedUser);
            this.$message.success("Calendario compartido!");
          }
          if (data.AlreadyExists) {
            this.$message.error("El usuario ya tiene acceso a este calendario");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$message.error("Error al agregar usuario!");
        });
    },
    getAllUsersInCalendar() {
      this.loading = false;
      this.$http
        .get("/api/Calendario/GetEmployeesInCalendar", {
          params: {
            calendarID: this.calendarID
          }
        })
        .then((resp) => {
          this.usersInCalendar = resp.data;
        })
        .catch(() => {
          this.$message.error("Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeUser(user) {
      this.$http
        .delete("/api/Calendario/RemoveShareCalendar", {
          data: {
            CalendarID: this.calendarID,
            UserID: user.UserID
          }
        })
        .then(({ data }) => {
          if (data.Succeded) {
            const deletedUserIndex = this.usersInCalendar.findIndex(
              (u) => u.UserID == user.UserID
            );
            this.usersInCalendar.splice(deletedUserIndex, 1);
            this.$message.success("Usuario eliminado");
          } else if (data.CantRemoveCreator) {
            this.$message.error(
              "El creador del calendario no puede ser eliminado"
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    toggleEdit(user) {
      this.$http
        .put("/api/Calendario/ToggleEditPermission", {
          CalendarID: this.calendarID,
          UserID: user.UserID
        })
        .then(({ data }) => {
          if (data.Succeded) {
            this.$message.success("Permiso actualizado");
          } else if (data.CantRemoveCreator) {
            this.$message.error(
              "No puede actualizar permisos para el creador del calendario"
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },
  watch: {
    calendarID(val) {
      if (val) {
        this.getAllUser();
        this.getAllUsersInCalendar();
      }
    }
  }
};
</script>
